import { all, takeLatest, call, put, select } from "redux-saga/effects";
import {
  getCoursesTotalActionsSuccess,
  getCoursesTotalActionsFail,
  getCourseAnalyticsSuccess,
  getCourseAnalyticsFail,
  getBannersTotalActionsSuccess,
  getBannersTotalActionsFail,
  getBannerAnalyticsSuccess,
  getBannerAnalyticsFail,
  getEventListSuccess,
  getEventListFailure,
  getCoursesFailureByEventId,
  getCoursesSuccessByEventId,
  getBannersSuccessByEventId,
  getBannersFailureByEventId,
  getLessonsSuccessByCourseId,
  getLessonsFailureByCourseId,
} from "./actions";
import {
  getAnalyticsCourseUsersService,
  getAnalyticsCourseTotalActionsService,
  getAnalyticsBannerTotalActionsService,
  getAnalyticsBannerUsersService,
} from "../../../service/analytics.service";
import {
  getAdminLessonsInfoService,
  getInformaAcademyBannerService,
  getInformaAcademyCourseListService,
  getInformaAcademyEventService,
} from "../../../service/informaAcademy.service";

function* getCourseAnalyticsTotalActions() {
  const selectToken = (state) => state.auth.token;
  try {
    const token = yield select(selectToken);
    const response = yield call(getAnalyticsCourseTotalActionsService, {
      token,
    });

    const { status, data } = response;

    if (status !== 200)
      throw new Error("Failed to get course analytics totalActions");

    yield put(getCoursesTotalActionsSuccess(data));
  } catch (error) {
    yield put(getCoursesTotalActionsFail(error));
  }
}

function* getCourseAnalyticsUsers({ payload }) {
  const selectToken = (state) => state.auth.token;
  const {
    courseId,
    eventId,
    lessonId,
    year,
    startDate,
    endDate,
    page,
    perPage,
    sortBy,
    sortDirection,
  } = payload;

  try {
    const token = yield select(selectToken);
    const response = yield call(getAnalyticsCourseUsersService, {
      courseId,
      eventId,
      lessonId,
      year,
      startDate,
      endDate,
      page,
      perPage,
      sortBy,
      sortDirection,
      token,
    });

    const { status, data } = response;

    if (status !== 200) throw new Error("Failed to get course analytics users");

    yield put(
      getCourseAnalyticsSuccess({
        courseAnalytics: data.analyticsCourseOutputItems,
        total: data.paginationInfo.totalElements,
        pageInfo: data.paginationInfo,
        languageCounts: data.languageCounts,
        profileCounts: data.profileCounts,
      })
    );
  } catch (error) {
    yield put(getCourseAnalyticsFail(error));
  }
}

function* getBannerAnalyticsTotalActions() {
  const selectToken = (state) => state.auth.token;
  try {
    const token = yield select(selectToken);
    const response = yield call(getAnalyticsBannerTotalActionsService, {
      token,
    });

    const { status, data } = response;

    if (status !== 200)
      throw new Error("Failed to get course analytics totalActions");

    yield put(getBannersTotalActionsSuccess(data));
  } catch (error) {
    yield put(getBannersTotalActionsFail(error));
  }
}

function* getBannerAnalyticsUsers({ payload }) {
  const selectToken = (state) => state.auth.token;
  try {
    const token = yield select(selectToken);
    const {
      eventId,
      bannerId,
      year,
      startDate,
      endDate,
      page,
      perPage,
      sortBy,
      sortDirection,
    } = payload;
    const response = yield call(getAnalyticsBannerUsersService, {
      token,
      eventId,
      bannerId,
      year,
      startDate,
      endDate,
      page,
      perPage,
      sortBy,
      sortDirection,
    });

    const { status, data } = response;

    if (status !== 200) throw new Error("Failed to get course analytics users");

    yield put(
      getBannerAnalyticsSuccess({
        bannerAnalytics: data.analyticsBannerOutputItems,
        total: data.paginationInfo.totalElements,
        pageInfo: data.paginationInfo,
        languageCounts: data.languageCounts,
        profileCounts: data.profileCounts,
      })
    );
  } catch (error) {
    yield put(getBannerAnalyticsFail(error));
  }
}

function* getEventList() {
  const selectedToken = (state) => state.auth.token;

  try {
    const token = yield select(selectedToken);

    const response = yield call(getInformaAcademyEventService, {
      token,
    });

    if (response.status !== 200)
      throw new Error("Failed to get course analytics users");
    const { data } = response;
    const { events } = data;
    const mappedEvents = events.map((event) => {
      return {
        value: Number(event.id),
        label: event.name,
        year: event.year,
      };
    });

    const mappedYears = events.map((event) => {
      return {
        value: event.year,
        label: event.year,
      };
    });

    const years = [...new Set(mappedYears.map((item) => item.value))].map(
      (value) => {
        return { value, label: value };
      }
    );

    const eventsInfo = events.map(
      ({ eventEditionCode, homePageId, id, name, year }) => ({
        eventEditionCode,
        homePageId,
        id,
        name,
        year,
      })
    );

    yield put(
      getEventListSuccess({
        events: mappedEvents,
        eventsInfo,
        years,
      })
    );
  } catch (error) {
    yield put(getEventListFailure(error));
  }
}

function* getCoursesByEventId({ payload }) {
  const selectToken = (state) => state.auth.token;

  try {
    const { eventId } = payload;
    const token = yield select(selectToken);

    if (!eventId) return;

    const params = {
      eventId,
      token,
    };

    const response = yield call(getInformaAcademyCourseListService, params);

    const { courses } = response.data;
    const mappedCourses = courses.map((course) => {
      return {
        value: Number(course.courseId),
        label: course.courseTitle,
      };
    });
    const lessons = courses.map((course) => {
      return {
        courseId: Number(course.courseId),
        lessons: course.lessons.map((lesson) => ({
          value: Number(lesson.lessonId),
          label: lesson.title,
        })),
      };
    });

    yield put(getCoursesSuccessByEventId({ courses: mappedCourses, lessons }));
  } catch (error) {
    yield put(getCoursesFailureByEventId(error));
  }
}

function* getLessonsByCourseId({ payload }) {
  const selectToken = (state) => state.auth.token;

  try {
    const { courseId } = payload;
    const token = yield select(selectToken);

    if (!courseId) return;

    const params = {
      courseId,
      token,
    };

    const response = yield call(getAdminLessonsInfoService, params);

    const { lesson: lessons } = response.data;

    const mappedLessons = lessons.map((lesson) => ({
      value: Number(lesson.id),
      label: lesson.title,
    }));

    yield put(
      getLessonsSuccessByCourseId({
        lessons: mappedLessons,
      })
    );
  } catch (error) {
    yield put(getLessonsFailureByCourseId(error));
  }
}

function* getBannersByEventId({ payload }) {
  const selectToken = (state) => state.auth.token;

  try {
    const { eventId } = payload;
    const token = yield select(selectToken);

    if (!eventId) return;

    const params = {
      eventId,
      token,
    };

    const response = yield call(getInformaAcademyBannerService, params);

    const { banners } = response.data;

    const mappedBanners = banners.map((banner) => {
      return {
        value: Number(banner.id),
        label: banner.title,
      };
    });

    yield put(getBannersSuccessByEventId({ banners: mappedBanners }));
  } catch (error) {
    yield put(getBannersFailureByEventId(error));
  }
}

export default all([
  takeLatest("GET_COURSES_TOTAL_ACTIONS", getCourseAnalyticsTotalActions),
  takeLatest("GET_COURSE_ANALYTICS", getCourseAnalyticsUsers),

  takeLatest("GET_BANNERS_TOTAL_ACTIONS", getBannerAnalyticsTotalActions),
  takeLatest("GET_BANNER_ANALYTICS", getBannerAnalyticsUsers),

  takeLatest("GET_EVENT_LIST_ANALYTICS", getEventList),
  takeLatest("GET_COURSES_ANALYTICS", getCoursesByEventId),
  takeLatest("GET_LESSONS_ANALYTICS", getLessonsByCourseId),
  takeLatest("GET_BANNERS_LIST", getBannersByEventId),
]);
